var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.75,
    height: 36.3,
    viewBox: "0 0 35.75 36.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;}.cls-1,.cls-2,.cls-3{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.75px;}.cls-2{fill:#fff;}.cls-3{fill:#ff5f01;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.92,15.36,1.46,12.09A2.26,2.26,0,0,1,.38,10.17V5A2.23,2.23,0,0,1,2.61,2.78H6.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.83,15.36l5.46-3.27a2.27,2.27,0,0,0,1.09-1.92V5a2.24,2.24,0,0,0-2.24-2.23H28.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "20.68 24.97 20.68 30.28 28.83 33.3 28.83 35.92 6.92 35.92 6.92 33.03 15 30.28 15 24.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.92,2.78V15.83a2.39,2.39,0,0,0,.7,1.69l6.68,6.74A2.41,2.41,0,0,0,16,25h3.68a2.4,2.4,0,0,0,1.7-.7l6.74-6.75a2.4,2.4,0,0,0,.71-1.69v-13A2.4,2.4,0,0,0,26.42.38H9.33A2.4,2.4,0,0,0,6.92,2.78Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.78,
    y1: 7.11,
    x2: 22.79,
    y2: 7.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.8,
    y1: 11.69,
    x2: 20.55,
    y2: 11.69
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.dd1cb8713b41d88f2df7bf3beae431b8.svg";
export { ForwardRef as ReactComponent };